<script lang="ts">
	import RangeSlider from "svelte-range-slider-pips";

	export let values = [0, 6200];
	export let min = 0;
	export let max = 100;
	export let range: "min" | "max" = "min";
	export let float = true;
	export let prefix = "";
	export let suffix = "";
	export let step = 1;
	export let pips = true;
	export let pushy = false;
	export let pipstep = 1;
	export let gap = 1000;

	/**
	 * maintain a distance of 1 between the handles when
	 * the user is dragging the handle
	 */
	const slide = ({
		detail
	}: {
		detail: { activeHandle: number; value: number };
	}) => {
		if (values.length === 2) {
			if (detail.activeHandle === 0 && values[1] < detail.value + gap) {
				values[1] = detail.value + gap;
			}
			if (detail.activeHandle === 1 && values[0] > detail.value - gap) {
				values[0] = detail.value - gap;
			}
		}
	};

	/**
	 * enforce the gap between the handles when the user
	 * stops dragging the handle
	 */
	const stop = ({
		detail
	}: {
		detail: { activeHandle: number; value: number };
	}) => {
		if (values.length === 2) {
			if (detail.activeHandle === 0 && detail.value >= max - gap) {
				values[0] = max - gap;
			}
			if (detail.activeHandle === 1 && detail.value <= min + gap) {
				values[1] = min + gap;
			}
		}
	};
</script>

<RangeSlider
	{range}
	{pushy}
	{pips}
	{min}
	{max}
	bind:values
	{float}
	{pipstep}
	{prefix}
	{suffix}
	{step}
	on:change={slide}
	on:stop={stop}
	{...$$restProps}
/>
